(function () {
    'use strict';

    angular.module('app.users', [
        // Angular modules
        'ngRoute',

        // Custom modules
        'treeControl'
        // 3rd Party Modules

    ]);
})();